<template>
    <div id="content" v-show="!loading">
        <popup v-show="hasPopup"
               :popup-type="getPopupType"
               :popup-action="getPopupAction"
               @popup-action="executePopupAction"></popup>
        <form>
            <div class="inner">
                <p class="paging">
                    <router-link :to="{ name: moduleName }" class="btn btn_back" v-translate>Seznam</router-link>
                </p>
                <p class="buttons">
                    <a v-if="$_deleteActionAllowed" class="btn btn_action btn_delete" :title="'Smazat' | translate"
                       @click.prevent.stop="deleteEntity" v-translate>Smazat</a>
                </p>
                <h1 v-if="entity.name">{{ entity.name }}</h1>
            </div>

            <div class="responsiveTabs">
                <div class="tabs_content">
                    <section>
                        <div class="left">
                          <detail-entity-info :entity="entity"></detail-entity-info>
                        </div>
                        <protocol-form
                                :entity="entity"
                                ref="protocolformref"
                        ></protocol-form>
                    </section>
                    <section class="buttons">
                        <p>
                            <router-link :to="{ name: moduleName }" class="btn btn_back btn_seznam" v-translate>Seznam
                            </router-link>
                            <input v-if="$_updateActionAllowed" type="submit" :value="'Uložit' | translate"
                                   :class="['btn']"
                                   @click.prevent.stop="submitForm()">
                        </p>
                    </section>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
	import ProtocolForm from "@/components/views/protocols/ProtocolForm"
	import detailActions from "@/components/mixins/detail-actions"
	import protocols from "@/components/views/protocols/mixins/protocols"

	export default {
		name: "ProtocolDetail",
		components: {ProtocolForm},
		mixins: [detailActions, protocols],
		created(ProtocolService) {
			this.entityService = ProtocolService
			this.createdInit()
		},
		methods: {
			getEntity() {
				this.setLoadingMessage()

				return this.entityService.getEntity(this.$route.params.id, {id_selected_operator: this.$_loggedUser_selectedOperatorId})
					.then(data => {
						this.entity = data.protocol
						this.emptyMessage()
					})
					.then(() => {
						this.$refs['protocolformref'].validateProtocolFormRequiredFields()
					})
					.catch(function (error) {
						this.setErrorMessage(error['error_message'])
					}.bind(this))
			},
			updateEntity(params, redirect = false) {
				this.entityService.updateEntity(this.entity.id, this.filterFormParams({...params}))
					.then(() => {
						if (redirect === true) {
							this.redirect(this.moduleName)
						} else {
							this.emptyMessage()
							this.setSuccessMessage()
							this.getEntity()
						}
					})
					.catch(function (error) {
						this.setErrorMessage(this.processErrorMessage(error))
					}.bind(this))
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/views/protocols/ProtocolDetail.vue